<template>
    <div>
        <el-form ref="form1" :inline="true" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-form-item label="" class="query-form-item">
                    <el-button type="primary" icon="el-icon-back" @click="goBackList"></el-button>
                </el-form-item>
            </el-form-item>
        </el-form>

        <el-table v-loading="loading" :data="list" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  @selection-change="handleSelectionChange" :height="tableHeight"
                  border @sort-change="handleSortChange" :row-key="getRowKeys">
            <el-table-column label="ID" width="60" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="商品图片" width="120" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.img_url">暂无图片</div>
                    <img style="width:90px;height:90px;" :src="scope.row.img_url" v-else/>
                </template>
            </el-table-column>

            <el-table-column label="销售国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="scope.row.category_state.toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="采购人员" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.developer_username }} <br/>
                        {{ scope.row.developer_full_name }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="运营人员" width="150" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.operator_username }} <br/>
                        {{ scope.row.operator_fullname }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="运营状态" width="150" align="center">
                <template slot-scope="scope">
                    <div v-show="scope.row.operation_id">
                        <el-popover placement="top-start" width="300" trigger="hover"
                                    v-show="scope.row.operation_status == 0"
                                    :content="' 运营选中时间 ' + scope.row.assign_operation_time">
                            <a style="color: blue" slot="reference">待运营</a>
                        </el-popover>
                        <el-popover placement="top-start" width="300" trigger="hover"
                                    v-show="scope.row.operation_status == 1"
                                    :content="' 开始运营时间 ' + scope.row.operation_running_time">
                            <a style="color: blue" slot="reference">运营中</a>
                        </el-popover>
                        <el-popover placement="top-start" width="300" trigger="hover"
                                    v-show="scope.row.operation_status == -1"
                                    :content="' 不再运营时间 ' + scope.row.operation_fail_time">
                            <a slot="reference">不再运营</a>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="运营Asin数量" width="140" align="center">
                <template slot-scope="scope">
                    <a @click="operatorAsinList(scope.row)"  class="hover-effect canClick" >{{ scope.row.operator_asin_count }}</a>
                </template>
            </el-table-column>


            <el-table-column label="类目" min-width="400" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category }}</div>
                </template>
            </el-table-column>

            <el-table-column label="标题" min-width="150" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.title }}</div>
                </template>
            </el-table-column>


            <el-table-column label="1688产品链接" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-show="scope.row.ali_href_link" type="primary" size="mini"
                               @click="jumpUrl(scope.row.ali_href_link)">跳转
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column label="1688产品价格" min-width="100" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.ali_factory_price }}</div>
                </template>
            </el-table-column>


            <el-table-column label="长(cm)*宽(cm)*高(cm)-重(g)" width="190" align="center">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.long }}*{{ scope.row.wide }}*{{
                            scope.row.height
                        }}-{{ scope.row.weight }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="运输模式" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.deliver_mode }}</div>
                </template>
            </el-table-column>

            <el-table-column label="总运费" width="70" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight }}</div>
                </template>
            </el-table-column>

            <el-table-column label="运费单价/kg" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_unit_price }}</div>
                </template>
            </el-table-column>


            <el-table-column label="海空运费差价" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.freight_difference }}</div>
                </template>
            </el-table-column>

            <el-table-column label="0利润销售价格" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit }}</div>
                </template>
            </el-table-column>
            <el-table-column label="0利润销售价格(免税)" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.seller_price_no_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月利润" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit }}</div>
                </template>
            </el-table-column>

            <el-table-column label="1-9月利润(免税)" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.early_profit_no_tax }}</div>
                </template>
            </el-table-column>
            <el-table-column label="1-9月投资回报率" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{
                            scope.row['early_investment_return_rate'] ? accMul(scope.row['early_investment_return_rate'], 100) + '%' : '-'
                        }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="170" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="cardFunc(scope.row)">
                        卡片
                    </el-button>
                    <el-button style="margin: 5px 0 5px 10px" type="success" size="mini" @click="exportFunc(scope.row)">
                        导出
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :current-page="query.page"
            :page-sizes="[10, 50, 100]"
            :total="query.total"
            background
            style="display: flex;justify-content: end;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <child-info-modal :visible="ctrl.childInfoVisible" :info="childInfo"
                          @close-callback="closeCllback"></child-info-modal>
        <car-modal ref="card"></car-modal>
        <operatorListModal ref="operatorListModal" @refreshPage="closeCllback"/>

        <!--        <detail-preview ref="detailPreview"></detail-preview>-->
        <!--        <dataMigrationModal ref="dataMigrationModal" @refreshPage="closeCllback"></dataMigrationModal>-->
    </div>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {manager_index_get_cost_analysis_detail_datas} from '@/api/advAnalys/advAnalys.js'
import ChildInfoModal from './childInfoModal.vue'
import CarModal from './carModal.vue'
import {downloadFileUrl} from '@/utils/method'
import operatorListModal from '@/views/operationalSelection/components/operatorListModal.vue'

export default {
    components: {CarModal, ChildInfoModal, operatorListModal},
    data() {
        return {
            ids: [],
            multipleSelection: [],
            tableHeight: null,
            managerAnalysisList: [],
            developerList: [],
            list: [],
            loading: false,
            statusObj: {
                3: '建库导入完成',
                4: '获取基础信息中',
                5: '获取基础信息完成',
                6: '获取1688链接中',
                7: '重新获取1688链接中',
                0: '成本分析待解析',
                1: '成本分析解析中',
                2: '成本分析完成',
            },
            purchaseStatusObj: {
                0: '选品中',
                1: '采购中',
                2: '采购完成',
            },
            query: {
                page: 1,
                limit: 10,
                total: 0,
            },
            childInfo: {},
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
        }
    },
    mounted() {
        this.getManagerAnalysisList()

        window.addEventListener('resize', () => {
            if (this.$refs.form1) {
                this.tableHeight = window.innerHeight - 140 - this.$refs.form1.$el.offsetHeight
            }
        })

    },
    methods: {
        operatorAsinList(row){
            this.$refs.operatorListModal.showModal(row.id)
        },
        getRowKeys(row) {
            return row.id
        },
        goBackList() {
            this.query = {
                page: 1,
                limit: 10,
                total: 0,
            }
            this.list = []
            this.$emit('goBackList')
        },
        goBackFunc(data) {
            api.cost_analysis_personal_return_from_purchase_finish_list({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('回退成功')
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        //重置
        onReset() {
            this.query = {
                title: '',
                status: '',
                purchase_status: '',
                operation_id: '',
                developer_id: '',
                category_state: '',
                asin: '',
                deliver_mode: '',
                min_freight_difference: undefined,
                max_freight_difference: undefined,
                min_weight: undefined,
                max_weight: undefined,
                min_early_profit: undefined,
                max_early_profit: undefined,
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        detailFunc(data) {
            this.$refs.detailPreview.visible = true
            this.$refs.detailPreview.title = '详情展示'
            this.$refs.detailPreview.formData = data
            this.$refs.detailPreview.funcType = 1
        },
        cardFunc(data) {
            this.$refs.card.showModal(data)
        },
        exportFunc(data) {
            api.operation_index_export({id: data.id}).then((res) => {
                if (res.success) {
                    this.downFile(res.data)
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },
        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        // 数据迁移
        dataMigration() {
            if (this.multipleSelection.length > 0) {
                this.$refs.dataMigrationModal.showModal(this.subLibraryDetailInfo.id, this.multipleSelection)
            } else {
                this.$message.info('请勾选需要迁移的数据')
            }
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        chooseItem(data) {
            this.$emit('choose1688Info', data)
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        getList(ids) {
            if (ids) {
                this.ids = ids
                setTimeout(() => {
                    this.tableHeight = window.innerHeight - 140 - this.$refs.form1.$el.offsetHeight
                }, 1)
            }
            this.loading = true

            const queryParam = Object.assign({ids: this.ids}, this.query)

            api.manager_index_get_cost_analysis_detail_datas(queryParam).then(res => {
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.list = responseList
                    this.query.total = res.data.total || 0
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        getManagerAnalysisList() {
            api.manager_index_get_operator_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.managerAnalysisList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
            api.manager_index_get_developer_list().then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.developerList = responseList
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
    .canClick {
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }

    .fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>


